<template>
  <div id="adminHome">
    <div style="display: flex; flex-direction: row;   justify-content: space-between;" >
      <div style="display: flex; flex-direction: row; align-items: baseline;">
        <h2 style="font-weight: 100;">项目预览</h2>
        <div style="padding-left: 20px; color:#aaa">Dashboard</div>
      </div>
      <el-breadcrumb separator="/"  style="display: flex;align-items: center;">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>首页</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="box-container">
      <div class="dashboard-box box1">
        <div>{{ count.user }}</div>
        <div>项目数量</div>
      </div>
      <div class="dashboard-box box2"><div>{{ count.project }}</div>
        <div>路段数量</div></div>
      <div class="dashboard-box box3"><div>{{ count.segment }}</div>
        <div>切面数量</div></div>
      <div class="dashboard-box box4"><div>0</div>
        <div>异常数量</div></div>
    </div>
    <div>
      <div id="baiduMap" style="margin: 20px 0;width: 100%; height: calc(100vh - 350px);"></div>
    </div>
    <div style="text-align: left;">
      Copyright © 2024 <b>烟台图蓝电子科技有限公司</b>. All rights Reserved.
    </div>
  </div>
</template>

<script>

import api from '@/api/api'
import * as moment from 'moment';

export default {
  name: 'adminHome',
  components: {
  },
  data() {
    return {
      map: {},
      count: {
        user: 0,
        project: 0,
        segment: 0
      }
    }
  }, mounted() {
    const that = this;
    that.initMap();
    api.post('/homePageCount').then(response => {
      const r = response.data.data;
      that.count.user = r.user_count;
      that.count.project = r.project_count;
      that.count.segment = r.segment_count;
    });
  },
  methods: {
    initMap() {
      // 地图初始化逻辑
      const map = new BMapGL.Map('baiduMap');
      this.map = map;
      var opts = {
        offset: new BMapGL.Size(30, 30),
        anchor: BMAP_ANCHOR_BOTTOM_LEFT
      }
      var cityCtrl = new BMapGL.CityListControl(opts);  // 添加城市列表控件
      map.addControl(cityCtrl);
      // 启用鼠标滚轮缩放
      map.enableScrollWheelZoom(true);
      api.get('/allSegments').then(response => {
        const segments = response.data.data;
        segments.forEach(segment => {
          const marker = new BMapGL.Marker(new BMapGL.Point(parseFloat(segment.longitude), parseFloat(segment.latitude)));
          // 创建一个Label
          var label = new BMapGL.Label(segment.name, {
              offset: new BMapGL.Size(0, 0) // 设置文本标签的位置偏移
          });

          marker.setLabel(label);
          map.addOverlay(marker);
        });
      })
      this.go(103.930992,36.01512,6);
      return map;
    },
    go(lng, lat, level) {
      const point = new BMapGL.Point(lng, lat); // 使用您的坐标
      this.map.centerAndZoom(point, level || 20);
    }
  }
}
</script>

<style lang="less" scoped>
#adminHome {
  padding: 0 20px;
}

#baiduMap {
  border: 1px inset;
}

.buttons {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
}

.box-container {
  display: flex; flex-direction: row;   justify-content: space-between;
}
.dashboard-box {
  flex:2;
  width: 22%;
  height: 70px;
  position: relative;
  color:white;
  text-align: left;
  padding: 20px;
  margin-right: 20px;
}
.dashboard-box:last-child {
  margin-right:0;
}
.dashboard-box div:first-child {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  font-size: 36px
}
.dashboard-box div:last-child {
  font-size: 16px
}
.dashboard-box::after {
  content:"";
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: block;
  position:absolute;
  right:10px;
  top:-10px;
}
@media (max-width: 1280px) {
  .dashboard-box::after {
    display: none;
  }
}
.dashboard-box.box1 {
  background-color: #00c0ef 
}
.dashboard-box.box1::after {
  background-image: url('/img/1.png');
  width: 107px;
  height: 96px;
}

.dashboard-box.box2 {
  background-color: #00a65a
}
.dashboard-box.box2::after{
  background-image: url('/img/2.png');
  width: 96px;
  height: 105px;
}
.dashboard-box.box3 {
  background-color: #f39c12
}
.dashboard-box.box3::after{
  background-image: url('/img/3.png');
  width: 113px;
  height: 91px;
}
.dashboard-box.box4 {
  background-color: #dd4b39
}
.dashboard-box.box4::after{
  background-image: url('/img/4.png');
  width: 103px;
  height: 91px;
}
 
</style>
